







































import { Component, Prop, Vue } from 'vue-property-decorator';
import { CampaignBlockViewModel } from '@/types/contentServerContract';
import ResponsiveProductImage from '@/project/product/image/ResponsiveProductImage.vue';
import SmartHeadline from '@/core/ui-components/SmartHeadline.vue';
import ResponsiveIcon from '@/core/responsive/image/ResponsiveIcon.vue';
import dictionaryService from '@/core/translation/dictionary.service';

@Component({
    components: { ResponsiveIcon, SmartHeadline, ResponsiveProductImage }
})
export default class CampaignTeaser extends Vue {
    @Prop({ required: true, type: Object }) content!: CampaignBlockViewModel;
    @Prop({ type: Boolean, default: false }) iconInImage!: boolean;
    @Prop({ type: Boolean, default: false }) forceImageThumb!: boolean;

    get buttonText():string {
        return this.content.buttonText || dictionaryService.get('Campaigns.DefaultButtonText');
    }

    private get defaultCampaignIcon() {
        return this.content.iconUrl ? 'splash-campaign-no-icon' : 'splash-campaign';
    }
}
